var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "67px",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Tablet][Lanscape]01-MyClients",
    transform: "translate(-367.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(353.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E5E5E5",
    fill: "#FFFFFF",
    cx: 32.5,
    cy: 32.5,
    r: 33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 15.000000)",
    fill: "#E5E5E5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9620146,29.22375 L29.2119944,26.22375 C28.8561451,24.7683984 27.777288,23.5979883 26.3556483,23.1250195 L20.8554812,21.2925 C19.5141757,20.73375 18.9004483,18.57375 18.7679057,17.7537305 C19.7899253,16.9038867 20.4475406,15.6947461 20.605455,14.3749805 C20.5828958,14.1495703 20.6361004,13.9230469 20.7566895,13.7312109 C20.9515776,13.6824023 21.1111326,13.542832 21.1854315,13.3562109 C21.545324,12.4848047 21.7712089,11.5639453 21.855469,10.6249805 C21.8556448,10.5739453 21.8493751,10.5231445 21.8367185,10.47375 C21.7471848,10.1088867 21.5326674,9.78691406 21.2304327,9.56373047 L21.2304327,6.24996094 C21.2304327,4.23621094 20.6154162,3.40998047 19.9678793,2.93121094 C19.8442432,1.96125 18.8054653,3.55271368e-15 14.9803627,3.55271368e-15 C11.5866975,0.136640625 8.86681985,2.85644531 8.73017556,6.25001953 L8.73017556,9.56378906 C8.42794089,9.78697266 8.21342342,10.1089453 8.12388977,10.4738086 C8.11123318,10.5232031 8.10496348,10.5740625 8.10513927,10.6250391 C8.18928215,11.5644727 8.41516711,12.4857422 8.77517677,13.3575586 C8.82931884,13.5342188 8.97129531,13.6700977 9.15018683,13.7163281 C9.22020824,13.7513086 9.35146176,13.9325977 9.35146176,14.3750977 C9.51031367,15.6986133 10.1717377,16.9105078 11.1990308,17.7601172 C11.0677773,18.5788477 10.4577414,20.7376172 9.15399552,21.2825977 L3.60507716,23.1250781 C2.18455078,23.5979883 1.10639686,24.7672266 0.750020116,26.2213477 L-1.77635684e-14,29.2213477 C-1.77635684e-14,30.9815889 4.58062081,35.5562502 14.4806479,35.5562502 C24.3806749,35.5562502 29.9620146,31.0920699 29.9620146,29.22375 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientNoImage);
export default __webpack_public_path__ + "static/media/client-no-image.bb199175a9fa091c2784ae6d840fff5f.svg";
export { ForwardRef as ReactComponent };